module.exports = __webpack_public_path__ + "static/media/download-to-pdf-icon-0.593f76d4.jpg";